var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar",style:({ height: _vm.barHeight, 'background-color': _vm.bg })})}
var staticRenderFns = []

export { render, staticRenderFns }